import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../services/mysql.service';


import { Job } from '../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';




import { FileUploaderService } from './../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';
import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  GroupSettingsModel, IFilter, IFilterUI } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import { TabsetComponent } from 'ngx-bootstrap/tabs';

@Component({
  selector: 'app-agent-jobs',
  templateUrl: './agent-jobs.component.html',
  styleUrls: ['./agent-jobs.component.css'],
  providers: [ToolbarService, ExcelExportService]
})
export class AgentJobsComponent implements OnInit {


 
    //sycfustion Grip
  //public data: Object[];
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  today = new Date();
 

  job_id: number;
  client_job_data: Object;
  currentUserVAR: any;
  sessionUserId: any;
  sessionUserName: any;
  sessionBrandId: any;
  sessionUserLevel: any;
  sessionUserFullName: any;

  @ViewChild('staticTabs') staticTabs: TabsetComponent;
  brand_id: any;
  sessionUsername: any;
  all_router_details: string;

  constructor(private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,  public gfunc: GlobalFunctionsService) {


// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));



      this.job_id = +this.route.snapshot.paramMap.get('job_id');

      this.brand_id = this.gfunc.sessionBrandId;






      }

  ngOnInit() {
  }



 /// TABS
 selectTab(tab_id: number) {
  this.staticTabs.tabs[tab_id].active = true;
};


}




